import * as React from 'react';
import Button from '../button';
export default function PickerButton(props) {
    return React.createElement(Button, Object.assign({ size: "small", type: "primary" }, props));
}
